import { config } from 'affiny-core/env';
import { capitalize } from 'affiny-core/helpers/string/capitalize';
import { EBrand } from 'affiny-core/types/env.types';
import { IconName, Svg } from 'affiny-desktop/src/components/svg';
import React from 'react';

interface ILogo {
  isLayer?: boolean;
}
export const Logo = (props: ILogo) => {
  const brandCountry = config.configStrategy.getCountry();
  const brandName = config.configStrategy.getBrand?.();

  const LogoSuffix = `${capitalize(brandName)}${
    brandName === EBrand.PA ? brandCountry : ''
  }${props.isLayer ? 'Layer' : ''}`;

  return <Svg type={`Logo${LogoSuffix}` as IconName} />;
};
